// import external dependencies
// Polyfills
import "custom-event-polyfill/polyfill.js";
import "es6-object-assign/dist/object-assign-auto.js";
import "paroller.js/dist/jquery.paroller.min.js";
import "smoothscroll-for-websites/SmoothScroll.js";

import "jquery";

// Import everything from autoload
import "./autoload/_bootstrap.js";

import "./global/flickity";
import "./global/nav";
// import './global/swiper';
import "./global/search";

// import local dependencies
import Router from "./util/Router";
import common from "./routes/common";
import home from "./routes/home";
import singleProduct from "./routes/product";
import woocommerceCheckout from "./routes/checkout";
import googlemaps from "./routes/googlemaps";

import Swiper, { Navigation, Pagination } from "swiper";

const swiper = new Swiper(".swiper", {
  direction: "horizontal",
  loop: false,
  slidesPerView: 1.5,
  spaceBetween: 15,
  // configure Swiper to use modules
  modules: [Navigation, Pagination],
  navigation: {
    nextEl: ".treenext",
    prevEl: ".treeprev",
  },
  pagination: {
    el: ".tree-pagination",
    type: "bullets",
  },
  breakpoints: {
    480: {
      slidesPerView: 2,
    },
    640: {
      slidesPerView: 2,
    },
    1200: {
      slidesPerView: 4,
    },
  },
});

const catswiper = new Swiper(".catswiper", {
  direction: "horizontal",
  loop: false,
  slidesPerView: 1.5,
  spaceBetween: 30,
  // configure Swiper to use modules
  modules: [Navigation, Pagination],
  navigation: {
    nextEl: ".catnext",
    prevEl: ".catprev",
  },
  pagination: {
    el: ".cat-pagination",
    type: "bullets",
  },
  breakpoints: {
    480: {
      slidesPerView: 2,
    },
    640: {
      slidesPerView: 3,
    },
    940: {
      slidesPerView: 5.5,
    },
  },
});

const cross_slider = new Swiper(".cross-slider", {
  loop: false,
  slidesPerView: 2,
  spaceBetween: 30,
  // allowTouchMove: TRUE,

  // configure Swiper to use modules
  modules: [Navigation, Pagination],
  navigation: {
    nextEl: ".crossnext",
    prevEl: ".crossprev",
  },
  pagination: {
    el: ".crosspag",
    type: "bullets",
  },
});

const related = new Swiper(".related-slider", {
  direction: "horizontal",
  loop: false,
  slidesPerView: 1,
  spaceBetween: 30,
  breakpoints: {
    640: {
      slidesPerView: 1,
    },
    789: {
      slidesPerView: 1,
    },
    940: {
      slidesPerView: 4,
    },
  },
  modules: [Navigation, Pagination],
  navigation: {
    nextEl: ".relatednext",
    prevEl: ".relatedprev",
  },
  pagination: {
    el: ".relatedpag",
    type: "bullets",
  },
});

const sub = new Swiper(".subslider", {
  direction: "horizontal",
  loop: false,
  slidesPerView: 1,
  spaceBetween: 30,
  breakpoints: {
    640: {
      slidesPerView: 2,
    },
    789: {
      slidesPerView: 2,
    },
    940: {
      slidesPerView: 2.5,
    },
  },
  modules: [Navigation],
  navigation: {
    nextEl: ".subnextnext",
    prevEl: ".subprev",
  },
});

const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // Page with google maps
  googlemaps,
  singleProduct,
  woocommerceCheckout,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js